import { Button, Card, CardContent, Typography } from "@mui/material";
import { MdIntegrationInstructions } from "react-icons/md";

const integrations = [
  {
    name: "AmoCRM",
    icon: <MdIntegrationInstructions />
  },
];
/**
 * Страница для настройки интеграций агента
 * Список доступных интеграций:
 * - WhatsApp
 * - Telegram
 * - Instagram
 * @returns
 */
export const AgentIntegrations = () => {
  const handleConnect = (name: string) => {
    console.log(`Подключение к ${name}`);
  };
  return (
    <div>
      <h3 className="mb-8">Интеграции</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
        {integrations.map((integration) => (
          <Card key={integration.name}>
            <CardContent>
              <div className="flex justify-center items-center w-full h-full mb-4">
                <div className="flex justify-center items-center mr-2 text-2xl">{integration.icon}</div>
                <Typography variant="body1">{integration.name}</Typography>
              </div>
              <Button
                fullWidth
                variant="text"
                color="primary"
                onClick={() => handleConnect(integration.name)}
              >
                Подключить
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
